import { render, staticRenderFns } from "./BusOrderList.vue?vue&type=template&id=004ffd4c"
import script from "./BusOrderList.vue?vue&type=script&lang=js"
export * from "./BusOrderList.vue?vue&type=script&lang=js"
import style0 from "./BusOrderList.vue?vue&type=style&index=0&id=004ffd4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports